import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';

/**
 * AuthContext do marketplace — SÓ para o admin (/plans-admin).
 * As páginas de checkout NÃO usam auth: o contexto do usuário vem
 * pelo redirect assinado do HUB (query params validados no backend).
 *
 * NÃO existe cadastro público — o admin é seedado via env do backend
 * (ADMIN_SEED_EMAIL + ADMIN_SEED_PASSWORD no .env do marketplace/backend).
 */
const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('mkt_token');
    const savedUser = localStorage.getItem('mkt_user');

    if (token && savedUser) {
      try {
        setUser(JSON.parse(savedUser));
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      } catch {
        localStorage.removeItem('mkt_token');
        localStorage.removeItem('mkt_user');
      }
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    const response = await api.post('/auth/login', { email, password });
    const { access_token, user: userData } = response.data;

    localStorage.setItem('mkt_token', access_token);
    localStorage.setItem('mkt_user', JSON.stringify(userData));
    api.defaults.headers.common['Authorization'] = `Bearer ${access_token}`;

    setUser(userData);
    return userData;
  };

  const logout = () => {
    localStorage.removeItem('mkt_token');
    localStorage.removeItem('mkt_user');
    delete api.defaults.headers.common['Authorization'];
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
